export default __webpack_public_path__ + "static/media/girl.020c9011.png";